import { useState } from "react";
import { useSearchParams } from "react-router-dom";

export const useJournalEntries = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedTab, setSelectedTab] = useState(
    searchParams.get("tab") || "all_entries_tab",
  );
  const journalTabs = [
    {
      label: "All Entries",
      key: "all_entries_tab",
      showOnLocalSetup: false,
    },
    {
      label: "Posted",
      key: "posted_tab",
      showOnLocalSetup: false,
    },
    {
      label: "Draft",
      key: "draft_tab",
      showOnLocalSetup: false,
    },
    {
      label: "Review",
      key: "review_tab",
      showOnLocalSetup: false,
    },
    {
      label: "Voided",
      key: "voided_tab",
      showOnLocalSetup: false,
    },
    {
      label: "Cancelled",
      key: "cancelled_tab",
      showOnLocalSetup: false,
    },
  ];

  const updateSelectedTab = (key) => {
    searchParams.set("tab", key);
    searchParams.delete("page");
    searchParams.delete("store_id");
    searchParams.delete("start_date");
    searchParams.delete("end_date");
    setSearchParams(searchParams, { replace: true });
    setSelectedTab(key);
  };

  return {
    journalTabs,
    selectedTab,
    updateSelectedTab,
  };
};
